import { doTagCloseDepositWarning } from 'components/newAccountSteps/profileSteps/ProfileStep1/tagging';

export const closeDepositWarning = formActions => {
    doTagCloseDepositWarning();
    formActions.change('userProfile.showJointHolderDepositAdvise', false);
};
